<!-- @format -->

@if (options$ | async; as options) {
  <sis-search-filter-combobox [key]="key" [label]="label" [options]="options" />
}
